import React from "react";
import { AHInput, Box } from "arkh";
import { FormattedMessage } from "react-intl";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { OrgSpaceCreateTitles } from "./OrgSpaceCreateTitles";

export const OrgSpaceCreatePageNameSubTitle = (
  <FormattedMessage
    defaultMessage="Choose a name that reflects the content's intended purpose."
    description="OrgSpaceCreatePageName description"
  />
);

export function OrgSpaceCreatePageName(props: {
  name: string;
  setName: (name: string) => void;
}) {
  const intl_tokens = useIntlTokens();
  return (
    <Box spaceHorizontal="xlarge">
      <OrgSpaceCreateTitles
        title={
          <FormattedMessage
            defaultMessage="Give it a name"
            description="OrgSpaceCreatePageName title"
          />
        }
        subTitle={OrgSpaceCreatePageNameSubTitle}
      />
      <AHInput
        autoFocus
        value={props.name}
        onChangeText={props.setName}
        color="surface"
        cornerRadius="large"
        space="medium"
        placeholder={intl_tokens.Name}
      />
    </Box>
  );
}
